import { testimonials } from "pham-sushi/data/testimonial";
import { truncateFullWord } from "pham-sushi/helpers/utils";

export const getTestimonials = () => {
    return testimonials.map(item => ({
        ...item,
        shortQuote: truncateFullWord(item.quote, 250)
    }));
}